
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from 'vue'
// import { ElMessage } from 'element-plus'
import CTable from '@/components/c-table'
import { toResult } from '@/utils/toResult'
import { gabOrgSessions, detail } from './api'
import { getTableConfig1 } from './config'
export default defineComponent({
  components: { CTable },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      titlename: '详情',
      formdata: ref<any>({}),
      isSaasSession: false,
    })

    const tableConfig1 = reactive({
      ...getTableConfig1(),
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
    }
    // 初始化
    const init = async () => {
      const p = { id: props.row.id }
      const [err, res] = await toResult(gabOrgSessions(p))
      if (err) return false
      tableConfig1.data = res || []
      const [err1, res1] = await toResult(detail(p))
      if (err1) return false
      data.formdata = res1
      if (data.formdata.saasSession !== null) {
        data.isSaasSession = true
      }
    }
    onMounted(() => {
      data.formdata = props.row
      init()
    })

    // 格式化JSON字符串
    const formatJsonString = (jsonStr: string) => {
      try {
        const parsed = JSON.parse(jsonStr)
        return JSON.stringify(parsed, null, 2)
      } catch (error) {
        return jsonStr // 如果不是有效的JSON，返回原字符串
      }
    }

    return {
      ...toRefs(data),
      tableConfig1,
      onCancel,
      init,
      formatJsonString,
    }
  },
})
